var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('a-icon',{attrs:{"type":"clock-circle","theme":"filled"}}),_vm._v("\n        You can order from "+_vm._s(_vm.fromTime)+" to "+_vm._s(_vm.toTime)+"!\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }